var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEye = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 16,
  viewBox: "0 0 24 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.846886C7.41454 0.846886 3.25621 3.35563 0.187788 7.4305C-0.0625959 7.76434 -0.0625959 8.23074 0.187788 8.56459C3.25621 12.6444 7.41454 15.1531 12 15.1531C16.5855 15.1531 20.7438 12.6444 23.8122 8.5695C24.0626 8.23565 24.0626 7.76925 23.8122 7.43541C20.7438 3.35563 16.5855 0.846886 12 0.846886ZM12.3289 13.0371C9.28506 13.2286 6.7714 10.7198 6.96287 7.67106C7.11998 5.15741 9.15741 3.11997 11.6711 2.96287C14.7149 2.7714 17.2286 5.28014 17.0371 8.32893C16.8751 10.8377 14.8377 12.8751 12.3289 13.0371ZM12.1767 10.71C10.537 10.8131 9.18196 9.46302 9.28997 7.82326C9.37343 6.46824 10.4732 5.37343 11.8282 5.28505C13.4679 5.18196 14.823 6.53206 14.7149 8.17183C14.6266 9.53175 13.5268 10.6266 12.1767 10.71Z",
  fill: "#989898"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.563a847d.svg";
export { ForwardRef as ReactComponent };